<script>
import ModalControl from "@/components/ModalControl";
import { removeOsanoButtons } from "./configs/osano";
import { useResourcesStore } from "./stores/resources";
import { useUserStore } from "./stores/user";

export default {
  components: {
    ModalControl,
  },
  setup() {
    const user = useUserStore();
    const resources = useResourcesStore();
    if (window.Cypress) {
      window.store = { user, resources };
    }

    // Remove the osano cookie modal button as asked by the client
    window.Osano("onInitialized", removeOsanoButtons);
    window.Osano('onUiChanged', (component, stateChange) => {
      if (component === 'drawer' && stateChange === 'show') {
        removeOsanoButtons();
      }
    });
    // Remove osano in us
    window.Osano.cm.addEventListener('osano-cm-initialized', () => {
      const juridiction = (window.Osano.cm.jurisdiction || '').toLowerCase();
      const inUS = juridiction === 'us' || juridiction.indexOf('us-') === 0;
      if (inUS && juridiction !== 'us-ca') {
        document.documentElement.classList.add('osano-hide-dialog');
      } else {
        document.documentElement.classList.remove('osano-hide-dialog');
      }
      if (inUS) {
        document.documentElement.classList.add('osano-us-only');
      } else {
        document.documentElement.classList.remove('osano-us-only');
      }
    });
  },
};
</script>

<template>
  <div>
    <router-view />
    <ModalControl />
  </div>
</template>
